import { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { SelectButton } from "primereact/selectbutton";
import { ProblemFormatOptions } from "../Constants.ts";


export function WordProblemSettings() {
    const {settings, setSettings} = useContext(SettingsContext);

    function handleWordProblemSelection(value: ProblemFormatOptions) {
        let updatedSettings = {...settings}; 
        updatedSettings.WordProblems = value === ProblemFormatOptions.WordProblem ? true : false;
        setSettings(updatedSettings);
    }
    return(
        <div className='wordProblemContainer'>
            <SelectButton 
                value={settings.WordProblems ? ProblemFormatOptions.WordProblem : ProblemFormatOptions.MathFacts} 
                onChange={(e) => handleWordProblemSelection(e.value)} 
                options={ Object.values(ProblemFormatOptions) }
                className='select regrouping'                    
            />
        </div>
    );
}